// Форма добавления / редактирования подарка
export const GIFT_FORM_INITIAL = {
    open: false,
    id: '',
    name: '',
    image: '',
    cost: '',
    description: '',
    sort: '',
    active: '',
    establishments: [],
    price_id: '0'
};
// Форма платежа
export const PAYMENT_FORM_INITIAL = {
    open: false,
    id: '',
    payment: [{ index: 1, cost: '', payment_method: { id: '', name: '' }}],
    discount: { id: '', name: 'Нет скидки', percent: '0' },
    total_sum: '',
    date: ''
};
// Форма добавления / редактирования товара
export const GOODS_FORM_INITIAL = {
    open: false,
    id: '',
    name: '',
    description: '',
    cost: '',
    image: '',
    sort: '',
    active: '',
    group: { id: '', name: '' },
    establishments: []
};
// Форма добавления / редактирования группы товаров
export const GROUP_FORM_INITIAL = {
    open: false,
    id: '',
    name: '',
    sort: '',
    establishments: []
};
// Форма продажи товара
export const STORE_FORM_INITIAL = {
    open: false,
    user: { id: '', name: '', sum: '', subscriptions: '' },
    users: [],
    userInput: '',
    goods_id: '',
    goods_name: '',
    payment: [{ index: 1, cost: '', payment_method: { id: '', name: '' }}],
    discount: { id: '', name: 'Нет скидки', percent: '0' },
    total_sum: '',
    amount: ''
};
// Форма продажи абонемента
export const ADD_SUBSCRIPTION_FORM_INITIAL = {
    open: false,
    user: { id: '', name: '', sum: '', subscriptions: '', deposits: '' },
    users: [],
    userInput: '',
    workouts_count: { id: '', name: '' },
    type: { id: '', name: '' },
    coach: { id: '', name: 'Без тренера' },
    duration: { id: '', name: '' },
    constraint: { id: '', name: 'Нет ограничений' },
    note: '',
    activation: false,
    activation_date: '',
    expire_date: '',
    payment: [{ index: 1, cost: '', payment_method: { id: '', name: '' }}],
    discount: { id: '', name: 'Нет скидки', percent: '0' },
    total_sum: '',
    addition_date: ''
};
// Форма продажи разового занятия
export const ONE_TIME_WORKOUT_FORM_INITIAL = {
    open: false,
    user: { id: '', name: '', sum: '', subscriptions: '', deposits: '' },
    users: [],
    userInput: '',
    type: { id: '', name: '' },
    coach: { id: '', name: '' },
    payment: [{ index: 1, cost: '', payment_method: { id: '', name: '' }}],
    discount: { id: '', name: 'Нет скидки', percent: '0' },
    total_sum: '',
    date: '',
    time: ''
};
// Форма записи
export const BOOKING_FORM_INITIAL = {
    open: false,
    id: '',
    date: '',
    time: '',
    type: { id: '', name: '' },
    coach: { id: '', name: '' },
    name: '',
    max_users: '',
    hide_users: 0,
    bound_subscriptions: [],
    color: '',
    remind_datetime: '',
    start_registration_date: { id: '0', name: 'Без ограничений' },
    start_registration_time: '',
    finish_registration_hours: '',
    canceled: '',
    hide_in_app: 0
};
// Форма списка записанных пользователей
export const BOOKING_USERS_FORM_INITIAL = {
    open: false,
    id: '',
    users: [],
    userInput: '',
    checkedUsers: [],
    canceled: '',
    datetime: '',
    date: '',
    time: '',
    type: { id: '', name: '' },
    coach: { id: '', name: '' }
};
// Начальное значение календаря
export const CALENDAR_INITIAL = {
    open: false,
    dates: [],
    title: '',
    prev: '',
    next: '',
    today: '',
    type: ''
};
// Начальное состояние записей на неделю
export const WEEK_BOOKING_INITIAL = {
    week: '',
    prev: '',
    next: '',
    week_booking: [],
    date: '',
    today: '',
    current_week: '',
    next_weeks: [],
    not_current_week: false
};
// Начальное состояние формы прайса
export const PRICE_FORM_INITIAL = {
    open: false,
    id: '',
    name: '',
    cost: '',
    sale: '',
    description: '',
    establishments: [],
    type: { id: '', name: '' },
    time_constraint: { id: '', name: '' },
    coach: { id: '', name: '' },
    duration: { id: '', name: '' },
    times: { id: '', name: '' },
    with_coach: '0',
    one_time: '0',
    online_payment: '0',
    renewal_discount: '0',
    hide_in_app: '0',
    first_time_pay: '0'
};
// Начальное состояние формы метода оплаты
export const PAYMENT_METHODS_FORM_INITIAL = {
    name: '',
    active: 1,
    online: 0,
    deposit: 0,
    debt: 0,
    establishments: []
};
// Начальное состояние фильтров по пользователям
export const FILTER_USERS_INITIAL = {
    without_subscriptions: '0',
    expire_to: '',
    workouts_less_than: '',
    registration_not_later: '',
    not_been_x_months: '',
    last_workout_from: '',
    last_workout_to: '',
    birthday_from: '',
    birthday_to: '',
    admin: '0',
    coach: '0',
    workouts_count: '',
    debt: '0',
    without_workouts: '0'
};
// Начальное состояние формы огпаничений для абонементов
export const SUBSCRIPTION_CONSTRAINT_FORM_INITIAL = {
    id: '',
    name: '',
    establishments: [],
    schedule: {
        mon: [{ from: '', to: '' }],
        tue: [{ from: '', to: '' }],
        wed: [{ from: '', to: '' }],
        thu: [{ from: '', to: '' }],
        fri: [{ from: '', to: '' }],
        sat: [{ from: '', to: '' }],
        sun: [{ from: '', to: '' }]
    }
};
// Начатьлое состояние формы пользователя
export const USER_FORM_INITIAL = {
    open: false,
    title: '',
    id: '',
    avatar: '',
    name: '',
    phone: '',
    email: '',
    date_registration: '',
    sex: '',
    note: '',
    birthday: '',
    additional_id: '',
    links: []
};
// Начальное состояние дат статистики
export const STATISTIC_DATES_INITIAL = {
    from: '',
    to: ''
};
// Начальная состояние формы абонемента
export const SUBSCRIPTION_FORM_INITIAL = {
    open: false,
    title: '',
    user: { id: '', name: '' },
    users: [],
    userInput: '',
    times: '',
    type: { id: '', name: '' },
    coach: { id: '', name: 'Без тренера' },
    constraint: { id: '', name: 'Нет ограничений' },
    note: '',
    unlim: '0',
    expire_date: '',
    activation_date: '',
    old_cost: '',
    payment: [],
    discount: { id: '', name: 'Нет скидки', percent: '0' },
    total_sum: ''
};
// Начальное значение селекта
export const SELECT_INITIAL = {
    type: null,
    current: ''
};
// Начальное состояние формы задачи
export const TASK_FORM_INITIAL = {
    open: false,
    id: '',
    description: '',
    target_date: '',
    target_time: '',
    responsible: '',
    status: '',
    color: '',
    urgent: '0'
};
// Начальное состояние формы добавления типа абонемента
export const SUBSCRIPTION_TYPE_FORM_INITIAL = {
    id: '',
    name: '',
    duration: '',
    hide_booking: '0',
    hide_subscription: '0',
    hide_one_time: '0',
    establishments: [],
    color: ''
};
// Начальное состояние формы переноса данных пользователя по номеру телефона
export const TRANSFER_USER_DATA_FORM_INITIAL = {
    open: false,
    wrongPhone: '',
    correctPhone: ''
};
// Начальное состояние формы редактирования прав пользователя
export const USER_PERMISSION_FORM_INITIAL = {
    open: false,
    u_id: '',
    role: 'user',
    coach: { id: '', name: '' }
};
// Начальное состояние формы уведомлений в записи
export const BOOKING_NOTIFICATION_FORM_INITIAL = {
    open: false,
    booking_id: '',
    title: '',
    message: ''
};
// Начальное состояние формы срока действия абонемента
export const SUBSCRIPTION_DURATION_FORM_INITIAL = {
    id: '',
    name: '',
    interval: {
        day: 0,
        month: 0,
        year: 0
    },
    establishments: [],
    freeze_days: 0,
    freeze_times: 0
};
// Начальное состояние формы номера ключа
export const KEY_NUMBER_FORM_INITIAL = {
    open: false,
    number: '',
    workout_id: '',
    type: ''
};
// Начальное состояние абонемента который просматриваем
export const CURRENT_SUBSCRIPTION_INITIAL = {
    subscription_id: '',
    current_workouts: [],
    count: ''
};
// Начальное состояние формы списания долга
export const REMOVE_DEBT_INITIAL = {
    open: false,
    workout_id: ''
};
// Начальное состояние календаря, для списания тренировки
export const SUBSCRIPTION_CALENDAR_INITIAL = {
    open: false,
    subscription_id: ''
};
// Начальное состояние формы акции, новости
export const PROMO_FORM_INITIAL = {
    open: false,
    id: '',
    image: '',
    name: '',
    description: '',
    code: '',
    discount: '',
    active: '1',
    establishments: [],
    news: '0',
    date: '',
    expire: '',
    goods: 0,
    link: ''
};
// Товары к которым применим промокод
export const PROMO_GOODS_FORM_INITIAL = {
    open: false,
    promo_id: '',
    promo_code: '',
    goods: []
};
// Начальное состояние текущего пользователя
export const CURRENT_USER_INITIAL = {
    id: '',
    name: '',
    avatar: '',
    phone: '',
    email: '',
    sex: '',
    date_registration: '',
    last_visit: '',
    subscriptions: [],
    additional_id: '',
    deposits: '',
    confirm_email: false,
    email_approved: false
};
// Начальное состояние добавления файла
export const UPLOAD_FILE_INITIAL = { link: '', name: '' };
// Начальное состояние формы тренера
export const COACH_FORM_INITIAL = {
    open: false,
    id: '',
    image: '',
    name: '',
    description: '',
    phone: '',
    email: '',
    hide: '0',
    establishments: [],
    links: []
};
// Начальное значение формы рассылки сообщений
export const PUSH_NOTIFICATION_FORM_INITIAL = {
    type: { id: 'push', name: 'Push - сообщения' },
    addressees: { id: '', name: 'Укажите адресата' },
    user: { id: '', name: '' },
    users: [],
    userInput: '',
    title: '',
    message: '',
    months: '',
    gender: { id: '', name: '' },
    type_workout: { id: '', name: '' }
};
// Начальное состояние пользователя (администратора)
export const USER_INITIAL = {
    id: '',
    hash: '',
    slug: '',
    name: '',
    phone: '',
    role: ''
};
// Начальное состояние автоматизаций
export const AUTOMATION_INITIAL = {
    happy_birthday: {
        id: '',
        title: '',
        message: '',
        establishments: []
    }
};
// Начальное состояние формы администратора
export const ADMIN_FORM_INITIAL = {
    open: false,
    id: '',
    name: '',
    establishments: [],
    restrictions: []
};
// Начальное состояние списка депозитов
export const DEPOSIT_LIST_INITIAL = {
    open: false,
    list: []
};
// Начальное состояние формы депозита
export const DEPOSIT_FORM_INITIAL = {
    open: false,
    id: '',
    sum: '',
    payment: [{ index: 1, cost: '', payment_method: { id: '', name: '' }}],
    discount: { id: '', name: 'Нет скидки', percent: '0' }
};
// Начальное состояние семейного абонемента
export const FAMILY_FORM_INITIAL = {
    open: false,
    subscription_id: '',
    owner: { id: 0, 'name': '' },
    users: [],
    userInput: '',
    checkedUsers: []
};
// Начальное состояние формы доплаты за тренировку
export const WORKOUT_PAYMENT_FORM_INITIAL = {
    open: false,
    workout_id: '',
    payment: [{ index: 1, cost: '', payment_method: { id: '', name: '' }}],
    discount: { id: '', name: 'Нет скидки', percent: '0' },
    total_sum: ''
};
// Смена количества товара на складе
export const REST_GOODS_FORM_INITIAL = {
    open: false,
    goods_id: '',
    rest: ''
};
// Расчёт з/п
export const SALARIES_DATA_INITIAL = {
    employees: [],
    date_from: '',
    date_to: '',
    coach_workout_cost: '0',
    coach_client_cost: '0',
    workouts_types_cost: {},
    consider_subscription_cost: '0',
    consider_subscription_percent: '0',
    one_time_percent: '0'
};
// Таблица лидеров
export const LEADERBOARD_INITIAL = {
    users: [],
    month_year: '',
    date_from: '',
    date_to: ''
};
// Форма списания тренировки из абонемента для группового занятия
export const AVAILABLE_SUBSCRIPTION__FORM_INITIAL = {
    open: false,
    subscriptions: [],
    user_id: 0,
    child_id: 0
};
// Форма отображения последних тренировок пользователя
export const LAST_BOOKING_FORM_INITIAL = {
    open: false,
    last_booking: []
};
// Форма редектирования списка детей пользователя
export const CHILDREN_FORM_INITIAL = {
    open: false,
    children: []
};
// Форма редактирования ребёнка
export const CHILD_FORM_INITIAL = {
    open: false,
    id: '',
    name: '',
    birthday: ''
};
// Начальное состояние отзывов
export const REVIEWS_INITIAL = {
    date_from: '',
    date_to: '',
    reviews: [],
    total_count: 0
};
// Начальное состояние формы смены пароля
export const CHANGE_USER_PASSWORD_FORM_INITIAL = {
    open: false,
    u_id: '',
    password: ''
};
// Начальное состояние списка долгов
export const DEBT_LIST_INITIAL = {
    open: false,
    u_id: 0,
    debt_list: []
};
// Начальное состояние кассы
export const CASH_INITIAL = {
    cash_list: [],
    cash_before: '',
    cash_after: '',
    payment_method: { id: '', name: '' },
    date_from: '',
    date_to: '',
    period: ''
};
// Начальное состояние формы кэша
export const CASH_FORM_INITIAL = {
    open: false,
    id: '',
    type: '',
    sum: '',
    payment_method: { id: '', name: '' },
    description: '',
    date: ''
};
// Начальное состояние списка контрагентов
export const COUNTERPARTIES_INITIAL = {
    counterparties: [],
    invoice: {
        date: '',
        number: 0,
        subject: '',
        period: ''
    },
    invoice_exclude: []
};
// Начальное состояние списка счетов
export const INVOICES_INITIAL = {
    invoices: [],
    date: '',
    months: []
};
// Начальное состояние формы отправки чека
export const SEND_RECEIPT_FORM_INITIAL = {
    open: false,
    invoice_id: 0,
    receipt_link: '',
    receipt_sum: 0,
    counterparty_id: 0,
    counterparty_name: '',
    period: '',
    period_name: ''
};
// Начальное состояние настроек
export const OTHER_SETTINGS_INITIAL = {
    sms_service: '',
    sms_username: '',
    sms_password: ''
};
// Начальное состояние формы смены адреса почты пользователя
export const CHANGE_USER_EMAIL_FORM_INITIAL = {
    open: false,
    email: ''
};
// Начальное состояние экрана с услугами
export const SERVICES_INITIAL = {
    date: '',
    schedule: [],
    masters_schedules: [],
    services: []
};
// Начальное состояние формы записи на услуги
export const SERVICES_FORM_INITIAL = {
    open: false,
    id: 0,
    master: { id: 0, name: '' },
    date: '',
    time: '',
    services: [],
    user: { id: 0, name: '', phone: '' },
    users: [],
    userInput: '',
    note: '',
    edit_mode: false
};
// Начальное состояние настроек расписания услуг
export const SERVICES_SETTINGS_INITIAL = {
    open: false,
    current_tab: 'masters',
    masters: [],
    services: [],
    specializations: []
};
// Начальное состояние формы мастера
export const MASTER_FORM_INITIAL = {
    open: false,
    id: 0,
    name: '',
    specialization: { id: 0, name: '' }
};
// Начальное состояние специализаци
export const SPECIALIZATION_FORM_INITIAL = {
    open: false,
    id: 0,
    name: ''
};
// Начальное состояние услуги
export const SERVICE_FORM_INITIAL = {
    open: false,
    id: 0,
    name: '',
    price: '',
    duration: '',
    net_duration: '',
    specialization: { id: 0, name: '' }
};
// Начальное состояние расписания мастера
export const MASTER_SCHEDULE_FORM_INITIAL = {
    open: false,
    id: 0,
    master_id: 0,
    master_name: '',
    month_year: '',
    days: [],
    prev_month: '',
    next_month: ''
};
// Начальное состояние формы продления абонемента
export const EXTEND_SUBSCRIPTION_FORM_INITIAL = {
    open: false,
    subscription_id: '',
    expire_date: ''
};
// Форма сопоставления мастеров и услуг
export const MASTER_SERVICES_FORM_INITIAL = {
    open: false,
    service_id: 0,
    masters: []
};
// Форма удаления данных
export const REMOVE_DATA_FORM_INITIAL = {
    date: '',
    workouts: 0,
    subscriptions: 0,
    payments: 0,
    booking: 0
};
// Форма редактирования расписания на день
export const MASTER_SCHEDULE_TIMES_FORM_INITIAL = {
    open: false,
    master_id: 0,
    date: '',
    times: [],
    new_time_from: '',
    new_time_to: ''
};
// Копирование расписания мастера
export const MASTER_COPY_SCHEDULE_DAYS_INITIAL = {
    active: false,
    copy_day: '',
    days: []
};
// Форма редактирования суммы счёта
export const INVOICE_SUM_FORM_INITIAL = {
    open: false,
    invoice_id: 0,
    sum: 0,
    unp: ''
};